import React, { memo, useCallback , Fragment} from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import style from './image-gallery.module.scss';
import Block from '../block';
import IntlString, { intlString } from '../intl-string';
import ImageGalleryGallery from '../image-gallery';

export default memo(
	/**
	 * @param {{
	 *   title: null | undefined | import("../../../tmp/graphql-types").IntlStringFragment,
	 *   addDownloadLink: boolean | null | undefined,
	 *   entries: import("../../../tmp/graphql-types").PageElementFrag_PageElementImageGallery_Fragment["imageGalleryEntries"],
	 * }} props
	 */
	function ImageGallery({title, addDownloadLink = false, entries}) {
		const intl = useIntl();

		const renderCaption = useCallback(
			/**
			 * @param {import("../../../tmp/graphql-types").PageElementFrag_PageElementImageGallery_Fragment["imageGalleryEntries"][number]} entry
			 * @return {React.ReactNode}
			 */
			(entry) => {
				const download = (() => {
					if (entry.title && entry.local) {
						return `${intlString(intl, entry.title)}${entry.local.ext}`;
					} else {
						return true;
					}
				})();

				return (
					<Fragment>
						{entry.copyright && (<IntlString {...entry.copyright} />)}
						{addDownloadLink && entry.local?.childImageSharp?.original && (
							<FormattedMessage
								id="element.imageGallery.downloadLink"
								values={{
									a(...inner) {
										return (
											<a
												className={style.downloadLink}
												href={entry.local?.childImageSharp?.original?.src || undefined}
												download={download}
											>
												{inner}
											</a>
										);
									},
								}}
							/>
						)}
					</Fragment>
				);
			},
			[addDownloadLink],
		);

		return (
			<Block padding>
				{title && (
					<h1 className={style.title}>
						<IntlString {...title} />
					</h1>
				)}

				<ul className={style.list}>
					{entries.map((entry, i) => {
						return (
							<li
								key={i}
								className={style.entry}
							>
								<ImageGalleryGallery
									imageStartIndex={i}
									images={entries}
									renderCaption={renderCaption}
								/>
								<h2 className={style.entryTitle}>
									{entry.title && (
										<IntlString {...entry.title} />
									)}
								</h2>
								<div className={style.entryCaption}>
									{renderCaption(entry)}
								</div>
							</li>
						);
					})}
				</ul>
			</Block>
		);
	}
);
